<template>
  <div class="layout-wrapper">
    <sidebar></sidebar>
    <main class="main-content-area">
      <header class="conversation-header centered-chat">
        <h2>Conversation with Kaelu</h2>
      </header>

      <section id="chatInterface" class="screen-section">
        <input type="hidden" id="bot" value="general">
        <div id="chatHistory" class="chat-history">
          <!-- #todo: get user data from store -->
        </div>

        <!-- Typing indicators -->
        <div id="thinking" class="typing-indicator hidden">
          <span class="material-symbols-rounded">waving_hand</span> Kaelu is thinking...
        </div>

        <div id="typing" class="typing-indicator hidden">
          <span class="material-symbols-rounded">waving_hand</span> Kaelu is typing...
        </div>

        <div id="input-area" class="chat-input-area centered-chat">
          <div class="input-wrapper floating-input">
<!--            <textarea id="chatQuestionInput" placeholder="Ask Kaelu..." rows="1"></textarea>-->

            <textarea
                id="chatQuestionInput"
                ref="chatQuestionInput"
                @keydown="handleKeydown"
                placeholder="Ask Kaelu..."
                rows="1"
            ></textarea>



            <button @click="ask" class="btn icon-btn send-btn">
              <span class="material-symbols-rounded">send</span>
            </button>
          </div>
        </div>
      </section>
      <!--      <button id="scrollToBottomBtn" class="scroll-btn hidden" onclick="scrollToBottom()">-->
      <!--        <span class="material-symbols-rounded">arrow_downward</span>-->
      <!--      </button>-->
    </main>
  </div>
</template>

<script setup>
import { onMounted, defineProps } from 'vue';
import Sidebar from "@/components/Sidebar.vue";
import {useAuthStore} from "@/stores/auth.js";
import { useConversationStore } from "@/stores/conversation.js";
import { marked } from "marked";

const authStore = useAuthStore();
const user = authStore.getUser();

const props = defineProps({
  uuid: String
});

onMounted(() => {
  if (props.uuid) {
    loadConversation(props.uuid);
  }
});

watch(() => props.uuid, (newUuid) => {
  if (newUuid) {
    loadConversation(newUuid);
  }
});

const loadConversation = (uuid) => {
  const chatHistory = document.getElementById('chatHistory');
  chatHistory.innerHTML = ''; // Clear any existing messages

  let messagesLength = 0;

  useConversationStore().getCurrentConversationMessages(uuid).then((messages) => {
    messages.forEach(message => {
      const messageDiv = document.createElement('div');
      messageDiv.className = `message ${message.actor === 'user' ? 'user-msg' : 'bot-msg'}`;

      let html = message.content;
      if(html.length > 0)
      {
        html = marked(message.content);
      }

      // add date and time to the message
      const date = new Date(message.created_at);
      const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
      const formattedDate = date.toLocaleDateString('en-US', options);
      html += `<div class="message-meta">${formattedDate}</div>`;

      messageDiv.innerHTML = html;
      chatHistory.appendChild(messageDiv);
      messagesLength++;
    });

    if (messagesLength > 0) {
      chatHistory.scrollTop = chatHistory.scrollHeight;
    } else {
      const welcomeMessage = document.createElement('div');
      welcomeMessage.className = 'message bot-msg';
      welcomeMessage.textContent = `Welcome! How can I assist you today?`;
      chatHistory.appendChild(welcomeMessage);
    }
  }).catch(error => {
    console.error('Error loading conversation messages:', error);
  });
};

const ask = async () => {
  const input = document.getElementById('chatQuestionInput');
  const chatHistory = document.getElementById('chatHistory');
  const thinkingIndicator = document.getElementById('thinking');
  const typingIndicator = document.getElementById('typing');

  if (input.value.trim() === '') return;

  let inputValue = input.value.trim();

  // clear the input field
  input.value = '';

  const userMessage = document.createElement('div');
  userMessage.className = 'message user-msg';
  userMessage.textContent = inputValue; // Set the user's message text

  let uMessage = userMessage.innerHTML.replace(/\n/g, '<br>');

  // add date and time to the message
  const date = new Date();
  const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
  const formattedDate = date.toLocaleDateString('en-US', options);
  uMessage += `<div class="message-meta">${formattedDate}</div>`;

  // if the message has new lines, replace them with <br> tags
  userMessage.innerHTML = uMessage;

  chatHistory.appendChild(userMessage);

  // Scroll to the bottom of the chat history
  chatHistory.scrollTop = chatHistory.scrollHeight;

  // Show thinking indicator
  // thinkingIndicator.classList.remove('hidden');

  // Show typing indicator
  typingIndicator.classList.remove('hidden');


  // send the question to the chatbot service
  useConversationStore().setChatId(props.uuid).then(() => {
    console.log('Chat ID set to:', props.uuid);
  });
  useConversationStore().ask('general', inputValue)
      .then(response => {
        if(response.data === '__NO_RESPONSE__') {
          const errorMessage = document.createElement('div');
          errorMessage.className = 'message bot-msg error-msg';
          errorMessage.textContent = 'Sorry, I am unable to respond at the moment. Please try again later.';
          chatHistory.appendChild(errorMessage);
          typingIndicator.classList.add('hidden');
          return;
        }

        // Show typing indicator
        typingIndicator.classList.remove('hidden');


        // Create and append bot's response message
        const botMessage = document.createElement('div');
        botMessage.className = 'message bot-msg';
        let html = response.data;
        if(html.length === 0) {
          botMessage.textContent = 'Sorry, I am unable to respond at the moment. Please try again later.';
          chatHistory.appendChild(botMessage);
          typingIndicator.classList.add('hidden');
          return;
        }
        html = marked(response.data); // Convert markdown to HTML
        botMessage.innerHTML = html;

        // botMessage.textContent = response.data; // Assuming response.data contains the bot's reply
        chatHistory.appendChild(botMessage);

        // Hide typing indicator
        typingIndicator.classList.add('hidden');
      })
      .catch(error => {
        console.error('Error sending message:', error);
        typingIndicator.classList.add('hidden');
      });
};

const handleKeydown = (event) => {
  if (event.key === 'Enter' && !event.shiftKey) {
    event.preventDefault(); // Prevent newline
    ask(); // Submit the form
  }
};

</script>
